import React from 'react';
import { Users, Info, Package } from 'lucide-react';
import { useLocalization } from '../../utils/hooks/useLocalization'
import styles from './BrandStory.module.css';

const BrandStory = () => {
  const { t, currentLanguage } = useLocalization();
  return (
    <section className={styles.brandStory}>
      <div className={styles.backgroundText}>URBAN</div>
      
      <div className={styles.container}>
            <h2 className={styles.title}>
              <span className={styles.titleMain}>OUR</span>
              <span className={styles.titleAccent}>CORE</span>
            </h2>
        
        <p className={styles.description}>
          {t("landing_brandStoryDescription")}
        </p>

        <div className={styles.grid}>
          <a className={styles.card} href={`/${currentLanguage}/artists`}>
            <Users className={styles.icon} size={48} />
            <h3 className={styles.cardTitle}>{t("landing_artists")}</h3>
            <h5 className={styles.cardDescription}>{t("landing_artistsDescription")}</h5>
          </a>
          
          <a className={styles.card} href={`/${currentLanguage}/story`}>
            <Info className={styles.icon2} size={48} />
            <h3 className={styles.cardTitle}>{t("landing_aboutUs")}</h3>
            <h5 className={styles.cardDescription}>{t("landing_aboutUsDescription")}</h5>
          </a>
          
          <a className={styles.card} href={`/${currentLanguage}/products`}>
            <Package className={styles.icon3} size={48} />
            <h3 className={styles.cardTitle}>{t("landing_products")}</h3>
            <h5 className={styles.cardDescription}>{t("landing_productsDescription")}</h5>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BrandStory;